export default "__VITE_ASSET__051d7a96__"